export class Appellant {
    public recId: number | null = null;
    public vehicleLicense: string | null = null;
    public vehicleState: string | null = null;
    public firstName: string | null = null;
    public lastName: string | null = null;
    public address1: string | null = null;
    public address2: string | null = null;
    public city: string | null = null;
    public state: string | null = null;
    public zip: string | null = null;
    public phone: string | null = null;
    public email: string | null = null;
}
